import React, { useEffect } from "react"
import "./lib/i18n"
import Providers from "./providers"
import packageJson from "../package.json"

function App() {
  useEffect(() => {
    console.debug("---------------- WISHAM PWA ----------------")
    addAppVersionToLocalStorage()
  }, [])

  function addAppVersionToLocalStorage() {
    const version = packageJson.version
    localStorage.setItem("appVersion", version)
  }

  return (
    <Providers/>
  )
}

export default App
